import { useMutation, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';
import { Axios } from '../../axios-instance';
import { BaseError } from '@utils/types/shared/base';
import {
  IssueDirectLicensePayload,
  IssueLicenseResponse
} from '@utils/types/back-office/licensing';
import { ADMIN_LICENSE_KEYS_QUERY_KEY } from './use-get-admin-license-keys';

const issueDirectLicense = async (
  payload: IssueDirectLicensePayload
): Promise<IssueLicenseResponse> => {
  const { data } = await Axios.post<IssueLicenseResponse>(
    'api/admin/licensing/keys',
    payload
  );
  return data;
};

/**
 * Issue a new license key directly, without a prior reseller request (#2019).
 *
 * Neither success nor error are toasted — the modal renders both inline:
 * the success view shows the generated key with a copy button, and the
 * form view shows a structured error block (status code, URL, detail) so
 * sysops can diagnose deploy/route issues without losing the context.
 */
export const useIssueDirectLicense = () => {
  const queryClient = useQueryClient();

  return useMutation<
    IssueLicenseResponse,
    AxiosError<BaseError>,
    IssueDirectLicensePayload
  >(issueDirectLicense, {
    onSuccess: () => {
      queryClient.invalidateQueries([ADMIN_LICENSE_KEYS_QUERY_KEY]);
    }
  });
};
